import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AvatareHistory() {
const [data, setData] = useState(null);
const navigate= useNavigate();

  useEffect(() => {
    const fetchChats = async () => {
        const userId = localStorage.getItem("UserId");
      try {
        const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/bot/getchats/?UserId=${userId}`, {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          cache: "default",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch chats");
        }

        const result = await response.json();
        setData(result?.message);
      } catch (error) {
        console.error("Error fetching chat data:", error);
      }
    };

    fetchChats();
  }, []);
  
    return (
      <div className="w-full bg-white p-4">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-4 px-6 font-medium ">Bot Name & Description</th>
              <th className="text-left py-4 px-6 font-medium ">Username</th>
              <th className="text-left py-4 px-6 font-medium ">Last Used Date</th>
              <th className="text-left py-4 px-6 font-medium ">Credits Used</th>
              <th className="text-left py-4 px-6 font-medium ">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((bot, index) => (
              <tr
                key={bot.id}
                className={` mt-20 ${
                  "bg-white"
                } border border-gray-300`}
              >
                <td className="py-4 px-6">
                  <div className="font-medium text-gray-900 text-sm mb-1">{bot?.BotName}</div>
                  <div className="text-gray-500 text-sm">{bot?.description}</div>
                </td>
                <td className="py-4 px-6 text-sm text-gray-900">{bot?.UserName}</td>
                <td className="py-4 px-6 text-sm text-gray-900">{bot?.ChatDateTime.split("T")[0]}</td>
                <td className="py-4 px-6 text-sm text-gray-900">{Number(bot?.total_credits)?.toFixed(5)}</td>
                <td className="py-4 px-6">
                  <button className="flex items-center justify-center transition-colors">
                    <div className="w-8 h-8 relative" onClick={()=>{navigate("/classroom/testMyAvatare")
                        localStorage.setItem("history",true)
                        localStorage.setItem("bot",JSON.stringify(bot))
                    }}>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <img src="/view-history.svg" />
                      </div>
                    </div>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  